module.exports = function ConvertToCSV(data) {
  const csv = [];
  data.forEach((row) => {
    csv.push({
      "Date Time Requested": row.datetimerequested,
      "Length of Elevation": row.lengthofelevation,
      Username: row.user,
      "Serial Number": row.serialnumber,
      Reason: row.reason,
      "Reason User Txt": row.reasonusertext,
    });
  });
  console.log(csv);
  return csv;
};
